import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = "/metals.php";

export function getMetals() {
    return api.get(service_path);
}

export function getMetalDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function createMetal(data, navigateBack) {
    api.post(service_path, data)
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Metal cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(body.message);
            }
        })
        .catch((error) => {
            console.log(error);
            globalToast.error("Houve um erro ao executar essa ação!");
        });
}

export function updateMetal(data, navigateBack) {
    api.patch(service_path, data)
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Metal editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(body.message);
            }
        })
        .catch((error) => {
            console.log(error);
            globalToast.error("Houve um erro ao executar essa ação!");
        });
}

export function deleteMetal(id) {
    return api.delete(service_path, { data: { id } })
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Metal desativado com sucesso!");
            } else {
                globalToast.error(body.message || "Houve um erro ao desativar esse metal!");
            }
        })
        .catch((error) => {
            globalToast.error(error.response?.data?.message || "Houve um erro ao desativar esse metal!");
            console.log(error);
        });
}
